import type { RouterProps } from 'contracts/Router';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import {
  BASE_SCHEDULED_REPORTS_PATH,
  SCHEDULED_REPORTS_ROUTES,
} from 'lib/routes';
import {
  InvoicesTrackingReportsPage,
  InventoryDailyItemsIntegralReportsPage,
  TripsTrackingReportsPage,
  ViagensBillingReportsPage,
} from 'pages/scheduled-reports';

export const scheduledReportsRoutes = ({
                                         isLoggedIn,
                                         location,
                                         hasPermissionTo,
                                       }: RouterProps): RouteObject => {
  const Fallback = <Navigate to={'/'} state={{ from: location }} />;

  return {
    path: BASE_SCHEDULED_REPORTS_PATH,
    element: isLoggedIn ? <Outlet /> : Fallback,
    children: [
      {
        path: SCHEDULED_REPORTS_ROUTES.invoicesTracking().path,
        element: <InvoicesTrackingReportsPage />,
      },
      {
        path: SCHEDULED_REPORTS_ROUTES.tripsTracking().path,
        element: <TripsTrackingReportsPage />,
      },
      {
        path: SCHEDULED_REPORTS_ROUTES.inventoryDailyItemsIntegral().path,
        element: <InventoryDailyItemsIntegralReportsPage />,
      },
      {
        path: SCHEDULED_REPORTS_ROUTES.viagensBilling().path,
        element: hasPermissionTo(SCHEDULED_REPORTS_ROUTES.viagensBilling().permissions)
          ? <ViagensBillingReportsPage /> : Fallback,
      },
    ],
  };
};
